<template>
    <div id="ContainerContact">
        <div class="page-height">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle"
                    v-bind:titlePrefix="
                        this.Mode
                            ? $t('Contact.EditPatientContact')
                            : $t('Contact.AddPatientContact')
                    "
                    v-bind:IsClinical="IsClinical"
                    v-bind:titleRef="'titleElementPatientContact'"
                    v-bind:patientCode="this.$route.params.id"
                >
                </MdTitleRegInfo>

                <div
                    class="alert alert-fill-warning d-flex align-items-center m-3"
                    role="alert"
                    v-if="isReadOnly"
                >
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>

                <!-- !! Important ,Added for testing purpose -->
                <div style="display:none;">
                    <MdEdit
                        v-bind:TypeProp="'text'"
                        v-model="this.ContactId"
                        v-bind:Id="'input_contact_id'"
                    >
                    </MdEdit>
                </div>
                <!-- End -->
                <b-row class="mt-3">
                    <b-col md="3">
                        <MdCheckBox
                            v-bind:Label="$t('Contact.PersonResponsible')"
                            v-bind:Name="'checkbox-1'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="Contact.primContact"
                            v-bind:isReadOnly="this.isReadOnly"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.FirstName')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'firstName'"
                            v-bind:MaxLengthProp="50"
                            v-bind:isRequired="true"
                            v-model="Contact.firstName"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:isValid="this.isFirstNameValid"
                            v-bind:Id="'input_contact_first_name'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.LastName')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'lastName'"
                            v-bind:MaxLengthProp="50"
                            v-bind:isRequired="true"
                            v-model="Contact.lastName"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:isValid="this.isLastNameValid"
                            v-bind:Id="'input_contact_last_name'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col lg="3" md="3" sm="12" class="mb-3">
                        <b-row>
                            <b-col cols="8">
                        <MdDateTime
                            :Label="$t('Shared.Dob')"
                            :Model="Contact.dob"
                            @input="Contact.dob = $event"
                            :Id="'PatientContactDob'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                            :ReadOnly="isReadOnly || Contact.dobUnknown"
                        >
                        </MdDateTime>
                            </b-col>
                            <b-col cols="4" class="d-flex align-items-end pb-2">
                        <MdCheckBox
                            v-bind:Label="$t('Shared.Unknown')"
                            v-bind:Name="'checkbox-dobUnknown'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="Contact.dobUnknown"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-on:change="DobUnknownChanged"
                        />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.ContactType')"
                            v-bind:Options="ContactTypeList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="Contact.contactType"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly"
                            :Input="ChangeDropDownType"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.Relation')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'relation'"
                            v-bind:MaxLengthProp="50"
                            v-model="Contact.relation"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_relation'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <b-row>
                            <b-col cols="8">
                        <MdEdit
                            v-bind:Label="$t('Shared.SSN')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'ssn'"
                            v-bind:MaxLengthProp="11"
                            v-model="Contact.ssn"
                            v-bind:isReadOnly="this.isReadOnly || Contact.ssnUnknown"
                            v-bind:Mask="'###-##-####'"
                            v-bind:Id="'input_ssn'"
                        >
                        </MdEdit>
                            </b-col>
                            <b-col cols="4" class="d-flex align-items-end pb-2">
                        <MdCheckBox
                            v-bind:Label="$t('Shared.Unknown')"
                            v-bind:Name="'checkbox-ssnUnknown'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="Contact.ssnUnknown"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-on:change="SsnUnknownChanged"
                        />
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdRadioGroup
                            v-bind:Label="$t('Shared.Sex')"
                            v-model="Contact.sex"
                            v-bind:Options="options"
                            v-bind:Name="'radio-inline'"
                            v-bind:isReadOnly="this.isReadOnly"
                        />
                    </b-col>
                </b-row>
                <MdTitle
                    v-bind:Text="$t('Shared.ContactInformation')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.CellPhone')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'cellPhone'"
                            v-bind:MaxLengthProp="20"
                            v-model="Contact.cellPhone"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_cellphone'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.DayPhone')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'dayPhone'"
                            v-bind:MaxLengthProp="20"
                            v-model="Contact.dayPhone"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_dayPhone'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.NightPhone')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'nightPhone'"
                            v-bind:MaxLengthProp="20"
                            v-model="Contact.nightPhone"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_nightphone'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <b-row>
                            <b-col cols="8">
                        <MdEdit
                            v-bind:Label="$t('Shared.Email')"
                            v-bind:TypeProp="'email'"
                            v-bind:Name="'email'"
                            v-bind:MaxLengthProp="100"
                            v-bind:isRequired="false"
                            v-model="Contact.email"
                            v-bind:isValid="this.emailValid"
                            v-bind:isReadOnly="this.isReadOnly || Contact.emailUnknown"
                            v-bind:Id="'input_contact_email'"
                        >
                        </MdEdit>
                            </b-col>
                            <b-col cols="4" class="d-flex align-items-end pb-2">
                        <MdCheckBox
                            v-bind:Label="$t('Shared.Unknown')"
                            v-bind:Name="'checkbox-emailUnknown'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="Contact.emailUnknown"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-on:change="EmailUnknownChanged"
                        />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <MdTitle
                    v-bind:Text="$t('Shared.Address')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row class="mt-3">
                    <b-col md="3">
                        <MdCheckBox
                            v-bind:Label="$t('Contact.UsePatientAddress')"
                            v-bind:Name="'checkbox-adress'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            @change="UsePatientAddress($event)"
                            v-bind:isReadOnly="this.isReadOnly"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.Address1')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'address1'"
                            v-bind:MaxLengthProp="30"
                            v-model="Contact.address1"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_addrs1'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.Address2')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'address2'"
                            v-bind:MaxLengthProp="30"
                            v-model="Contact.address2"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_addrs2'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.Zip')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'zip'"
                            v-bind:MaxLengthProp="10"
                            v-model="Contact.zip"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-on:blur="contactZipBlur(Contact.zip)"
                            v-on:change="contactZipChange($event)"
                            v-bind:Id="'input_zip'"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.City')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'city'"
                            v-bind:MaxLengthProp="25"
                            v-model="Contact.city"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_city'"
                        >
                        </MdEdit>
                    </b-col>
                </b-row>
                <b-row>
                    <!--<b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.State')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'state'"
                            v-bind:MaxLengthProp="20"
                            v-model="Contact.state"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_state'"
                        >
                        </MdEdit>
                    </b-col>-->
                    <b-col lg="3" md="3" sm="12" v-if="this.$store.state.companies.Country === 'United States' && isCountryUsa">
                        <MdSelect
                            v-bind:Label="$t('Shared.State')"
                            v-bind:Options="StateList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'state'"
                            v-bind:Model="Contact.state"
                            v-bind:Tag="'State'"
                            v-bind:Multiple="false"
                            :IsDisabled="isReadOnly"
                            :Input="ChangeDropDownState"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12" v-else>
                            <MdEdit
                                 v-bind:Label="$t('Shared.State')"
                                 v-bind:TypeProp="'text'"
                                 v-bind:Name="'state'"
                                  v-bind:MaxLengthProp="20"
                                 v-model="Contact.state"
                                 v-bind:isReadOnly="isReadOnly"
                                 v-bind:Id="'input_contact_state'">
                            </MdEdit>
                    </b-col>
                    <!--<b-col md="3">
                        <MdEdit
                            v-bind:Label="$t('Shared.Country')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'country'"
                            v-bind:MaxLengthProp="25"
                            v-model="Contact.country"
                            v-bind:isReadOnly="this.isReadOnly"
                            v-bind:Id="'input_country'"
                        >
                        </MdEdit>
                    </b-col>-->
                    <b-col lg="3" md="3" sm="12">
                                    <MdSelect
                                        v-bind:Label="$t('Shared.Country')"
                                        v-bind:Options="CountryList"
                                        v-bind:FieldDescription="'name'"
                                        v-bind:FieldCode="'recId'"
                                        v-bind:Model="CountryModel"
                                        v-bind:Tag="'Country'"
                                        v-bind:Multiple="false"
                                        :IsDisabled="isReadOnly"
                                        :Input="ChangeDropDownCountry"
                                    />
                                </b-col>
                </b-row>
                <MdTitle
                    v-bind:Text="$t('Shared.AditionalInformation')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.ActiveReleaseOnFile')"
                            v-bind:Options="ActiveReleaseOnFile"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.releaseOnFile"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly"
                            :Input="ChangeDropDownFile"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12" class="mb-3">
                        <MdDateTime
                            :Label="$t('Contact.ActiveReleaseOnFileEndDate')"
                            :Model="Contact.endDateforActiveRelease"
                            @input="Contact.endDateforActiveRelease = $event"
                            :Id="'ActiveReleaseOnFileEndDate'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                            :ReadOnly="isReadOnly || Contact.releaseOnFile !== 'Y'"
                        >
                        </MdDateTime>
                        <!--
                        <MdEdit
                            v-bind:Label="$t('Contact.ActiveReleaseOnFileEndDate')"
                            v-bind:TypeProp="'date'"
                            v-bind:Name="'ActiveReleaseOnFileEndDate'"
                            v-bind:Autocomplete="true"
                            v-bind:Min="'1900-01-01'"
                            v-bind:Max="'2200-12-31'"
                            v-model="Contact.endDateforActiveRelease"
                            @input="ChangeDateActiveOnRelease"
                            v-on:blur="OnActiveReleaseBlur(Contact.endDateforActiveRelease)"
                            v-bind:isReadOnly="this.isReadOnly || Contact.releaseOnFile !== 'Y'"
                        >
                        </MdEdit>
                        -->
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.gPortalAccess')"
                            v-bind:Options="YesNoUnknownNotApplicableOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.portalAccess"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.releaseOnFile !== 'Y'"
                            :Input="ChangeDropDownGrantPortalAccess"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.ReceiveNotification')"
                            v-bind:Options="YesNoUnknownNotApplicableOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.portalNotifications"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.releaseOnFile !== 'Y'"
                            :Input="ChangeDropDownPortalNotifications"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.ReceiveAppointment')"
                            v-bind:Options="YesNoUnknownNotApplicableOptions"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.appointmentNotifications"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.releaseOnFile !== 'Y'"
                            :Input="ChangeDropDownAppointmentNotifications"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.MayHavePhoneCalls')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.mayHavePhoneCalls"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly"
                            :Input="ChangeDropDownPhoneCalls"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.SupervisedPhoneCalls')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.supervisedPhoneCalls"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly"
                            :Input="ChangeDropDownSupervisedCalls"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.VisitationPermission')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.visitationPerm"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly"
                            :Input="ChangeDropDownVisitationPerm"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.MayVisit')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.mayVisit"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.visitationPerm === '0'"
                            :Input="ChangeDropDownMayVisit"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.UnsupervisedVisitsOnGrounds')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.unsupVisitsOnGrounds"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.visitationPerm === '0'"
                            :Input="ChangeDropDownVisitsOnGrounds"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.UnsupervisedVisitsOffGrounds')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.unsupVisitsOffGrounds"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.visitationPerm === '0'"
                            :Input="ChangeDropDownVisitsOffGrounds"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Contact.NeedProbationForOffGrounds')"
                            v-bind:Options="YesNoOptionsNumericThree"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:Model="Contact.needProbApprForOffGrounds"
                            v-bind:Multiple="false"
                            :IsDisabled="this.isReadOnly || Contact.visitationPerm === '0'"
                            :Input="ChangeDropDownApprForOffGrounds"
                        />
                    </b-col>
                </b-row>
                <MdTitle
                    v-bind:Text="$tc('Shared.Note', 2)"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <b-row>
                    <b-col md="12" lg="12">
                        <MdMemo
                            v-bind:Name="'textarea_notes'"
                            v-bind:Rows="'3'"
                            v-bind:MaxRows="'6'"
                            v-bind:MaxLength="'500'"
                            v-model="Contact.note"
                            v-bind:isReadOnly="this.isReadOnly"
                        />
                    </b-col>
                </b-row>
                <div class="space-actions"></div>
            </div>
            <div class="page-actions">
                <MdButton
                    v-bind:Label="$t('Shared.Back')"
                    v-bind:Name="'btnpatientlist'"
                    v-bind:ClassProp="'secondary mx-2 btn-login'"
                    v-on:click="DiscardChanges"
                />

                <MdButton
                    v-bind:Label="$t('Shared.Save')"
                    v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                    v-on:click="ClickSaveCall"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_save_contact'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import ContactService from '@/services/contact.service';
import GlobalService from '@/services/global.service';
import Utils from '../../../../common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission';
import validator from 'validator';
import StateService from '@/services/state.service'
import CountryService from '@/services/country.service'

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$tc('Contact.PatientContact'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'ContactDetails',
    data() {
        return {
            ClickSave: false,
            isCountryUsa:true,
            patientAddress: {},
            patient:{},
            StateList:[],
            Mode: this.$attrs.editMode,
            Loading: true,
            DisabledOptionsPortal: false,
            RegistrationInfo: {},
            infoList: [],
            IsClinical: false,
            CountryList:[],
            CountryModel:{recId:null,name:null},
            Contact: {
                firstName: '',
                lastName: '',
                primContact: false,
                dob: null,
                dobUnknown: false,
                contactType: '',
                relation: '',
                ssn: '',
                ssnUnknown: false,
                sex: '',
                cellPhone: '',
                dayPhone: '',
                nightPhone: '',
                email: '',
                emailUnknown: false,
                address1: '',
                address2: '',
                zip: '',
                city: '',
                state: '',
                country: '',
                note: '',
                releaseOnFile: '',
                mayHavePhoneCalls: '',
                supervisedPhoneCalls: '',
                visitationPerm: '',
                mayVisit: '',
                unsupVisitsOnGrounds: '',
                unsupVisitsOffGrounds: '',
                needProbApprForOffGrounds: '',
                portalAccess: '',
                endDateforActiveRelease: null,
                portalNotifications: '',
                appointmentNotifications: ''
            },
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false,
                PatientCode: ''
            },

            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            ContactTypeList: [],
            ActiveReleaseOnFile: Utils.sortByText(EnumService.YesNoUnknownNotApplicableOptions),
            YesNoOptions: EnumService.YesNoOptions,
            YesNoUnknownNotApplicableOptions: Utils.sortByText(EnumService.YesNoUnknownNotApplicableOptions),
            YesNoOptionsNumericThree: Utils.sortByText(EnumService.YesNoOptionsNumericThree),
            YesNoOptionsNumericTwo: EnumService.YesNoOptionsNumericTwo,
            checkedUsePatientAddress: false,
            contactZipChanged: false,
            shippingData: [],
            options: [
                { text: this.$t('Shared.Male'), value: 'M' },
                { text: this.$t('Shared.Female'), value: 'F' },
                { text: this.$t('Shared.Unknown'), value: 'U' }
            ],
            formatted: '',
            selected: '',
            isFirstNameValid: true,
            isLastNameValid: true,
            isReadOnly: false,
            counterModelTypeList: 0,
            pendingChanges: false,
            emailValid: false,
            ContactId: '',
            isDOBValid: true,
            currentAppointmentDB: {
                guid: '',
                activitytypecode: '',
                employee: {
                    firstname: '',
                    lastname: ''
                }
            },
            appoContactRouteNames: [
                'patient-portal-contact',
                'patient-contact-add',
                'contact-details',
                'appointmentDB-Ctacts-add',
                'appointmentDB-Ctacts-details'
            ]
        };
    },

    methods: {
        ChangeDropDownCountry(item){
            this.CountryModel = item ? item : {recId:"",name:""};
            this.Contact.country = item ? item.recId.toString() : null;
             this.isCountryUsa = this.CountryModel?.name != 'United States' ? false : true;
        },

        ChangeDropDownState(item){
            this.Contact.state = item ? item.state : null;
        },

        goToPatientPortalContacts() {
            if (this.$route.query.all) {
                this.$router.push({ name: 'patients-portal-contacts' });
            } else {
                this.$router.push({
                    name: 'patients-portal-contacts',
                    params: { id: this.$route.params.id }
                });
            }
        },

       getStates(){
            if(this.$store.state.companies.Country === 'United States'){
                StateService.getAll()
            .then((response) => {
                 if(response.status == '200'){
                  this.StateList = response.data;
                 }
          })
           .catch((error) => {
               if (error.response) {
                 this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
           });
            }
        },

        getCountryByRecId(arr,id){
            let name = "";
            arr.forEach(element => {
                if(element.recId?.toString() == id){
                    name = element.name;
                }
            });

            return name;
        },

        getRecIdByCountry(arr,country){
         let RecId = "";
            for(var i = 0; i < arr.length; i++){
                if(arr[i].name && arr[i]?.name?.toLowerCase() === country?.toLowerCase()){
                    RecId = arr[i].recId;
                    break;
                }
            }
            return RecId.toString();
    },

        PreSelectCountry(){
            if(this.$attrs.editMode){
            this.CountryModel.recId = this.Contact.country;
            this.CountryModel.name = this.getCountryByRecId(this.CountryList,this.Contact.country);
            }else{
                this.CountryModel.recId = this.getRecIdByCountry(this.CountryList,this.$store.state.companies.Country);
                this.CountryModel.name = this.$store.state.companies.Country;
                this.Contact.country = this.CountryModel.recId;
            }
        },

        SelectContactCountryByPatient(recid){
            this.CountryModel.recId = recid;
            this.CountryModel.name = this.getCountryByRecId(this.CountryList,recid);
            this.Contact.country = this.CountryModel.recId;
        },

        getCountries(){
            CountryService.getCountries()
            .then((response) => {
                 if(response.status == '200'){
                  this.CountryList = response.data;
                  this.PreSelectCountry();
                 }
          })
           .catch((error) => {
               if (error.response) {
                 this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
           });
        },

        DiscardChanges() {
            if (this.$route.name.includes('patient-portal-contact')) {
                this.goToPatientPortalContacts();
            } else if (
                this.$route.name === 'contact-details' ||
                this.$route.name === 'patient-contact-add'
            ) {
                this.$router.push({
                    name: 'patient-contacts',
                    params: { id: this.$route.params.id }
                });
            } else if (
                this.$route.name === 'appointmentDB-Ctacts-add' ||
                this.$route.name === 'appointmentDB-Ctacts-details'
            ) {
                this.$router.push({
                    name: 'appointmentDB-Ctacts',
                    params: { id: this.$route.params.id, actId: this.$route.params.actId }
                });
            } else {
                this.$router.push({
                    name: 'Clinical-cont',
                    params: { id: this.$route.params.id, recordid: this.$route.params.recordid }
                });
            }
        },
        ChangeDropDownType(value) {
            this.Contact.contactType = value ? value.code : '';
        },
        DobUnknownChanged(value) {
            if (value) {
                this.Contact.dob = null;
            }
        },
        SsnUnknownChanged(value) {
            if (value) {
                this.Contact.ssn = '';
            }
        },
        EmailUnknownChanged(value) {
            if (value) {
                this.Contact.email = '';
            }
        },
        ChangeDropDownFile(value) {
            this.Contact.releaseOnFile = value ? value.value : '';
            if (value && value.code !== 'Y') {
                this.Contact.endDateforActiveRelease = null;
                this.Contact.portalAccess = '';
                this.Contact.portalNotifications = '';
                this.Contact.appointmentNotifications = '';
            }
        },
        ChangeDropDownPhoneCalls(value) {
            this.Contact.mayHavePhoneCalls = value ? value.value : '';
        },
        ChangeDropDownSupervisedCalls(value) {
            this.Contact.supervisedPhoneCalls = value ? value.value : '';
        },
        ChangeDropDownVisitationPerm(value) {
            this.Contact.visitationPerm = value ? value.value : '';
            if (this.Contact.visitationPerm === '0') {
                this.Contact.mayVisit = '0';
                this.Contact.unsupVisitsOnGrounds = '0';
                this.Contact.unsupVisitsOffGrounds = '0';
                this.Contact.needProbApprForOffGrounds = '0';
            }
        },
        ChangeDropDownMayVisit(value) {
            this.Contact.mayVisit = value ? value.value : '';
        },
        ChangeDropDownVisitsOnGrounds(value) {
            this.Contact.unsupVisitsOnGrounds = value ? value.value : '';
        },
        ChangeDropDownVisitsOffGrounds(value) {
            this.Contact.unsupVisitsOffGrounds = value ? value.value : '';
        },
        ChangeDropDownApprForOffGrounds(value) {
            this.Contact.needProbApprForOffGrounds = value ? value.value : '';
        },
        ChangeDropDownGrantPortalAccess(item) {
            this.Contact.portalAccess = item ? item.value : '';
        },
        ChangeDropDownPortalNotifications(item) {
            this.Contact.portalNotifications = item ? item.value : '';
        },
        ChangeDropDownAppointmentNotifications(item) {
            this.Contact.appointmentNotifications = item ? item.value : '';
        },

        onContextContactDOB(ctx) {
            this.formatted = ctx.selectedFormatted;
            this.selected = ctx.selectedYMD;

            if (ctx.selectedFormatted != 'No date selected') {
                this.Contact.dob = ctx.selectedFormatted;
            }
        },

        async UsePatientAddress(event) {
            this.checkedUsePatientAddress = event;

            if (this.checkedUsePatientAddress) {
                if (this.$route.name.includes('Clinical')) {
                    var infoList = await this.getInfoTitle(this.$route.params.id);
                    if (infoList.length > 0) {
                        this.patientAddress = infoList[0];
                        this.Contact.address1 = this.patientAddress.address1;
                        this.Contact.address2 = this.patientAddress.address2;
                        this.Contact.zip = this.patientAddress.zip;
                        this.Contact.city = this.patientAddress.city;
                        this.Contact.state = this.patientAddress.state;
                        this.Contact.country = this.patientAddress.country;
                        this.SelectContactCountryByPatient(this.patientAddress.country);
                    }
                } else {
                    this.Contact.address1 = this.patient.address1;
                    this.Contact.address2 = this.patient.address2;
                    this.Contact.zip = this.patient.zip;
                    this.Contact.city = this.patient.city;
                    this.Contact.state = this.patient.state;
                    this.Contact.country = this.patient.country;
                    this.SelectContactCountryByPatient(this.patient.country);
                }
            } else {
                this.Contact.address1 = '';
                this.Contact.address2 = '';
                this.Contact.zip = '';
                this.Contact.city = '';
                this.Contact.state = '';
                this.Contact.country = '';
            }
        },

        resetModal() {
            if (this.Mode == 'Add') {
                this.checkedUsePatientAddress = false;
            }
        },

        formatterDate(value) {
            return Utils.formatterDate(value);
        },

        async GetPatientByCode() {
            this.infoList = await this.getInfoTitle(this.$route.params.id);
            if (this.infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = this.infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
                this.patient = this.infoList[0];
            }
        },

        getContactById() {
            if (this.ContactId) {
                ContactService.get(this.ContactId)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.Contact = response.data;
                            let CountryName = this.getCountryByRecId(this.CountryList,this.Contact?.country);
                            this.isCountryUsa = CountryName != 'United States' ? false : true;

                            this.Contact.dob = this.formatterDate(this.Contact.dob);
                            this.PreSelectCountry();
                            /*this.Contact.endDateforActiveRelease = this.formatterDate(
                                this.Contact.endDateforActiveRelease
                            );*/
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        AddContact() {
            this.Contact.patientCode = this.$route.params.id;
            ContactService.addContact(this.Contact)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        if (this.ClickSave) {
                            if (this.$route.name.includes('patient-portal-contact')) {
                                this.goToPatientPortalContacts();
                            } else if (this.$route.name === 'patient-contact-add') {
                                this.$router.push({
                                    name: 'patient-contacts',
                                    params: { id: this.$route.params.id }
                                });
                            } else if (this.$route.name === 'appointmentDB-Ctacts-add') {
                                this.$router.push({
                                    name: 'appointmentDB-Ctacts',
                                    params: {
                                        id: this.$route.params.id,
                                        actId: this.$route.params.actId
                                    }
                                });
                            } else {
                                this.$router.push({
                                    name: 'Clinical-cont',
                                    params: {
                                        id: this.$route.params.id,
                                        recordid: this.$route.params.recordid
                                    }
                                });
                            }
                        }
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');

                    this.showResponseErrorMessage(error);
                });
            this.checkedUsePatientAddress = false;
        },

        UpdateContact() {
            this.Contact.patientCode = this.$route.params.id;
            ContactService.update(this.ContactId, this.Contact)
                .then(response => {
                    if (response.status == '200') {
                        this.$emit('load', true);
                        this.pendingChanges = false;
                        if (this.ClickSave) {
                            if (this.$route.name.includes('patient-portal-contact')) {
                                this.goToPatientPortalContacts();
                            } else if (this.$route.name === 'contact-details') {
                                this.$router.push({
                                    name: 'patient-contacts',
                                    params: { id: this.$route.params.id }
                                });
                            } else if (this.$route.name === 'appointmentDB-Ctacts-details') {
                                this.$router.push({
                                    name: 'appointmentDB-Ctacts',
                                    params: {
                                        id: this.$route.params.id,
                                        actId: this.$route.params.actId
                                    }
                                });
                            } else {
                                this.$router.push({
                                    name: 'Clinical-cont',
                                    params: {
                                        id: this.$route.params.id,
                                        recordid: this.$route.params.recordid
                                    }
                                });
                            }
                        }
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.$emit('load', false);
                    elemSaveBtn.removeAttribute('disabled');

                    this.showResponseErrorMessage(error);
                });
        },

        async getContactType() {
            await GlobalService.getContactType()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.ContactTypeList = response.data;
                    }
                    this.Loading = false;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ClickSaveCall() {
            this.ClickSave = true;
            this.SaveOrEdit();
        },

        SaveOrEdit() {
            if (!this.isReadOnly) {
                if (this.validate_entries()) {
                    if (this.validate_required()) {
                        elemSaveBtn.setAttribute('disabled', 'disabled');
                        this.pendingChanges = false;
                        if (this.Mode) {
                            this.UpdateContact();
                        } else {
                            this.AddContact();
                        }
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.CheckRedLabeledFields'),
                            'errorAutoHide'
                        );
                    }
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.InvalidFieldValuesDetected'),
                        'errorAutoHide'
                    );
                }
            }
        },

        contactZipBlur: function(value) {
            if (this.contactZipChanged) {
                GlobalService.getCityAndStateByZipCode(value)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            var obj = response.data;
                            if (obj.city) {
                                this.Contact.city = obj.city;
                                this.Contact.state = obj.state;
                            }
                            this.patientZipChanged = false;
                        }
                    })
                    .catch(error => {
                        this.Contact.city = '';
                        this.Contact.state = '';

                        this.showResponseErrorMessage(error);
                    });
            }
        },

        contactZipChange: function() {
            this.contactZipChanged = true;
        },

        validate_required() {
            this.isFirstNameValid =
                this.Contact.firstName &&
                this.Contact.firstName.trim() != '' &&
                this.Contact.firstName.length > 0
                    ? true
                    : false;
            this.isLastNameValid =
                this.Contact.lastName &&
                this.Contact.lastName.trim() != '' &&
                this.Contact.lastName.length > 0
                    ? true
                    : false;
            return this.isFirstNameValid && this.isLastNameValid;
        },

        validate_entries() {
            this.isDOBValid = true;
            if (this.Contact.dob) {
                this.isDOBValid = Utils.validateBirthDate(this.Contact.dob) ? true : false;
            }

            this.emailValid =
                Utils.isNullOrEmptyString(this.Contact.email) ||
                validator.isEmail(this.Contact.email);
            EventBus.$emit(
                'onCheckValid',
                this.Contact.email,
                'email',
                'input_contact_email',
                this.$t('Shared.Email'),
                this.emailValid
            );
            const result = this.isDOBValid && this.emailValid;
            return result;
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },
        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        },
        PopulatePatientTitle() {
            const {
                /*dob, */ dateFrom,
                dateTo,
                age,
                programName,
                patientName,
                ageFormatted
            } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);

            if (this.$route.name.includes('Clinical')) {
                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                //if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }
            if (this.appoContactRouteNames.some(route => this.$route.name.includes(route))) {
                this.PatientTitle.programName = '';
                this.PatientTitle.dateFrom = '';
                this.PatientTitle.dateTo = '';

                if (this.infoList.length > 0) {
                    /* eslint-disable no-unused-vars */
                    const { dob, firstname, lastname, age, ageFormatted } = this.infoList[0]; // Destructure for easier access
                    if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
                }
            }
        },
        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename = this.currentAppointmentDB.activitytypename;
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(
                this.currentAppointmentDB.transdate
            )} ${this.currentAppointmentDB.timein}`;
        },
        handleEmailFieldValidation(payload) {
            if (payload.field === 'email') {
                this.emailValid = payload.isValid;
                this.Contact.email = payload.value;
            }
        }
    },

    async mounted() {
        this.getCountries();
        this.getStates();
        if (this.$route.name.includes('patient-portal-contact')) {
            if (this.$route.query.all) {
                // Came from the all-patients Contacts view, which has no single
                // patient context, so there is no Patients Portal right menu to show.
                this.OptionsRightMenu.visible = false;
                this.OptionsRightMenu.btnvisible = false;
                this.OptionsRightMenu.btnPatientsPortalDashboardVisible = false;
                this.OptionsRightMenu.ItemsList = [];
            } else {
                // Keep showing the Patients Portal right menu (photo/options bar) that was
                // already visible on the previous portal view instead of hiding it.
                this.OptionsRightMenu.visible = false;
                this.OptionsRightMenu.btnvisible = false;
                this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
                this.OptionsRightMenu.ItemsList = JSON.parse(
                    JSON.stringify(EnumService.PatientsPortalSummaryItems)
                );
            }
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        } else {
            this.OptionsRightMenu.ItemsList = this.$route.name.includes('Clinical')
                ? EnumService.ClinicalItems
                : this.$route.name.includes('appointmentDB-Ctacts')
                ? EnumService.AppointmentItems
                : EnumService.PatientItems;
            this.OptionsRightMenu.visible = true;
            this.OptionsRightMenu.btnvisible = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.isReadOnly = await this.$store.state.isPatientContactsEHRReadOnly;
        this.$emit('load', this.Loading);
        await this.getContactType();
        this.OptionsRightMenu.Mode = this.Mode;
        this.ContactId = this.$route.params.contactid;

        if (
            this.$route.name.includes('patient-portal-contact') ||
            this.$route.name.includes('patient-contact-add') ||
            this.$route.name.includes('contact-details') ||
            this.$route.name.includes('appointmentDB-Ctacts-add') ||
            this.$route.name.includes('appointmentDB-Ctacts-details')
        ) {
            this.GetPatientByCode();
        }

        if (
            this.$route.name.includes('appointmentDB-Ctacts-add') ||
            this.$route.name.includes('appointmentDB-Ctacts-details')
        )
            await this.getCurrentAppointment();

        if (this.$route.name.includes('Clinical')) {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(
                this.$route.params.recordid
            );
            const { dob, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dob) this.RegistrationInfo.dob = Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? '0' : age;

            this.IsClinical = dateTo ? false : true;
        }

        this.PopulatePatientTitle();

        this.getContactById();
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_contact');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );

        EventBus.$on('email-field-validation', this.handleEmailFieldValidation);
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('email-field-validation', this.handleEmailFieldValidation);
    }
};
</script>
